import React from "react";
import products from "../data/wholesaleProducts";
import { ProductCard } from "./product";

const kicker =
  "text-[10px] font-bold uppercase tracking-[0.22em] text-fresh-sage";
const primaryButton =
  "inline-flex items-center justify-center gap-3 rounded-full bg-fresh-ink px-6 py-3 text-[11px] font-bold tracking-[0.12em] text-white transition hover:-translate-y-0.5 hover:bg-fresh-sage";
const softButton =
  "inline-flex items-center justify-center gap-2 rounded-full border border-fresh-line bg-white/70 px-5 py-3 text-[11px] font-bold tracking-[0.1em] text-fresh-ink transition hover:border-fresh-sage hover:bg-white";

export default function Home({ shop, openProduct }) {
  const moods = [
    [
      "Quiet focus",
      "Headphones",
      products[1],
      "For deep work, long flights and a little more room to think.",
      "bg-fresh-mint",
    ],
    [
      "Light movement",
      "Earbuds",
      products[4],
      "Open, compact listening that moves without closing off the day.",
      "bg-fresh-blush",
    ],
    [
      "Shared moments",
      "Speakers",
      products[13],
      "Warm sound for kitchens, balconies and slow evenings together.",
      "bg-fresh-sky",
    ],
  ];

  return (
    <main className="bg-fresh-paper text-fresh-ink p-2 sm:p-3 lg:p-[18px]">
      <section className="bg-fresh-mint grid min-h-[680px] overflow-hidden rounded-[28px] lg:grid-cols-[1.15fr_0.85fr_180px]">
        <div className="relative flex min-h-[380px] items-center justify-center bg-white/30 p-8 lg:min-h-0">
          <img
            className="h-[82%] w-[82%] object-contain mix-blend-multiply drop-shadow-[0_28px_30px_rgba(52,68,63,.12)]"
            src={products[0].images[0]}
            alt={products[0].title}
          />
          <span className="absolute bottom-7 left-7 rounded-full bg-white/75 px-4 py-2 text-[10px] font-bold tracking-[0.18em]">
            NEW · HALO ONE
          </span>
        </div>
        <div className="flex flex-col justify-center px-7 py-14 sm:px-12 lg:px-16">
          <p className={kicker}>A SOFTER WAY TO LISTEN</p>
          <h1 className="mt-5 font-serif text-[clamp(3.6rem,7vw,7.6rem)] leading-[0.84] tracking-[-0.06em]">
            Make space
            <br />
            for your sound.
          </h1>
          <p className="text-fresh-ink/70 mt-8 max-w-lg text-base leading-7">
            Thoughtful audio objects in calm finishes, created for focus,
            movement and rooms that feel like your own.
          </p>
          <div className="mt-9 flex flex-wrap gap-3">
            <button
              className={primaryButton}
              onClick={() => openProduct(products[0])}
            >
              MEET HALO ONE <span>→</span>
            </button>
            <button className={softButton} onClick={() => shop("All")}>
              EXPLORE ALL 28
            </button>
          </div>
        </div>
        <aside className="border-fresh-ink/10 grid grid-cols-3 border-t bg-white/25 lg:grid-cols-1 lg:border-l lg:border-t-0">
          {["Adaptive quiet", "Soft-touch comfort", "Original design"].map(
            (text, i) => (
              <div
                className="border-fresh-ink/10 flex flex-col justify-end p-5 [&:not(:last-child)]:border-r lg:[&:not(:last-child)]:border-b lg:[&:not(:last-child)]:border-r-0"
                key={text}
              >
                <span className="text-fresh-sage text-[10px] font-bold">
                  0{i + 1}
                </span>
                <p className="mt-2 text-xs leading-5">{text}</p>
              </div>
            ),
          )}
        </aside>
      </section>

      <section className="mx-auto max-w-[1500px] px-2 py-24 sm:px-6 lg:py-32">
        <header className="mb-12 flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <p className={kicker}>SHOP BY MOMENT</p>
          <h2 className="font-serif text-[clamp(2.8rem,5vw,5.5rem)] leading-[0.92] tracking-[-0.045em] md:text-right">
            Where will sound
            <br />
            meet you today?
          </h2>
        </header>
        <div className="grid gap-3 lg:grid-cols-3">
          {moods.map(([title, cat, item, copy, tone], i) => (
            <button
              key={cat}
              onClick={() => shop(cat)}
              className={`hover:shadow-soft group grid min-h-[500px] overflow-hidden rounded-[24px] text-left transition hover:-translate-y-1 ${tone}`}
            >
              <div className="p-7 sm:p-9">
                <span className="text-[10px] font-bold">0{i + 1}</span>
                <h3 className="mt-7 font-serif text-4xl tracking-[-0.04em]">
                  {title}
                </h3>
                <p className="text-fresh-ink/65 mt-4 max-w-xs text-sm leading-6">
                  {copy}
                </p>
                <b className="mt-7 inline-block text-xs tracking-[0.12em]">
                  {cat} →
                </b>
              </div>
              <img
                className="h-60 w-full self-end object-contain mix-blend-multiply transition duration-500 group-hover:scale-105"
                src={item.images[0]}
                alt=""
              />
            </button>
          ))}
        </div>
      </section>

      <section className="rounded-[28px] bg-white px-3 py-16 sm:px-7 lg:px-60 lg:py-24">
        <header className="mb-10 flex flex-wrap items-end justify-between gap-5">
          <div>
            <p className={kicker}>LOVED RIGHT NOW</p>
            <h2 className="mt-4 font-serif text-[clamp(3rem,6vw,6rem)] leading-none tracking-[-0.05em]">
              Trending products
            </h2>
          </div>
          <button className={softButton} onClick={() => shop("All")}>
            VIEW COLLECTION →
          </button>
        </header>
        <div className="grid grid-cols-2 gap-6 xl:grid-cols-4">
          {[4, 6, 12, 19].map((i) => (
            <ProductCard
              key={products[i].id}
              item={products[i]}
              openProduct={openProduct}
            />
          ))}
        </div>
      </section>

      <section className="bg-fresh-blush my-3 grid overflow-hidden rounded-[28px] lg:grid-cols-[0.85fr_1.15fr_260px]">
        <div className="flex flex-col justify-center p-8 sm:p-12 lg:p-16">
          <p className={kicker}>CINEMA, GENTLY REFRAMED</p>
          <h2 className="mt-5 font-serif text-[clamp(3.2rem,6vw,6.5rem)] leading-[0.88] tracking-[-0.05em]">
            Big sound.
            <br />
            Calm room.
          </h2>
          <p className="text-fresh-ink/70 mt-7 max-w-sm leading-7">
            Cinema Arc opens a dimensional sound field while keeping the room
            visually quiet.
          </p>
          <button
            className={`${primaryButton} mt-8 self-start`}
            onClick={() => openProduct(products[20])}
          >
            DISCOVER CINEMA ARC <span>→</span>
          </button>
        </div>
        <div className="flex min-h-[420px] items-center justify-center bg-white/25 p-8">
          <img
            className="h-full w-full object-contain mix-blend-multiply"
            src={products[20].images[0]}
            alt={products[20].title}
          />
        </div>
        <div className="border-fresh-ink/10 flex flex-col justify-end border-t p-8 lg:border-l lg:border-t-0">
          <span className="text-[10px] font-bold tracking-[0.18em]">
            DESIGN NOTE 04
          </span>
          <p className="text-fresh-ink/65 mt-4 text-sm leading-6">
            A low silhouette, simple connection and sound that grows beyond the
            object.
          </p>
        </div>
      </section>

      <section className="bg-fresh-ink grid rounded-[28px] text-white sm:grid-cols-2 lg:grid-cols-4">
        {[
          ["30 days", "Listen at home"],
          ["2 years", "Limited warranty"],
          ["$75+", "Delivery on us"],
          ["Human help", "When you need it"],
        ].map(([title, copy], i) => (
          <article
            className="border-white/10 p-7 lg:p-10 [&:not(:last-child)]:border-b sm:[&:not(:last-child)]:border-b-0 sm:[&:not(:last-child)]:border-r"
            key={title}
          >
            <span className="text-[10px] text-white/45">0{i + 1}</span>
            <h3 className="mt-12 font-serif text-3xl">{title}</h3>
            <p className="mt-2 text-sm text-white/60">{copy}</p>
          </article>
        ))}
      </section>

      <section className="bg-fresh-sky my-3 flex flex-col justify-between gap-10 rounded-[28px] p-8 sm:p-12 lg:flex-row lg:items-end lg:p-16">
        <div>
          <p className={kicker}>THE VARSENIC SIGNAL</p>
          <h2 className="mt-4 font-serif text-[clamp(2.8rem,5vw,5rem)] tracking-[-0.04em]">
            A quieter kind of inbox.
          </h2>
          <p className="text-fresh-ink/65 mt-3">
            New releases, useful listening notes and no unnecessary noise.
          </p>
        </div>
        <form
          className="border-fresh-ink flex w-full max-w-xl border-b pb-2"
          onSubmit={(e) => e.preventDefault()}
        >
          <input
            className="placeholder:text-fresh-ink/45 min-w-0 flex-1 bg-transparent px-1 py-3 outline-none"
            type="email"
            required
            placeholder="Your email address"
          />
          <button className="text-xs font-bold tracking-[0.14em]">
            JOIN →
          </button>
        </form>
      </section>
    </main>
  );
}
